import React, { useEffect, useContext } from "react";
import { AppContext } from '../AppContext';
import Chart, { instances } from "chart.js";
import { config } from '../helpers/constants';

export default function DashboardChart(props) {
    const state = useContext(AppContext);
    const s = state.strings;
    const chartRef = React.createRef();
    const height = props.height ? props.height : "130px";

    useEffect(() => {

        const myChartRef = chartRef.current.getContext("2d");

        var updated = false;
        Chart.helpers.each(Chart.instances, function (instance) {
            if (instance.canvas.id == props.id) {
                // if the chart is currently visible, just update the data
                if (instance.canvas.offsetParent !== null) {
                    var newData = {
                        labels: props.labels,
                        datasets: props.datasets
                    }
                    instance.data = newData;
                    instance.options.title = { text: props.title, display: props.title ? true : false };
                    instance.update();
                    updated = true;
                } else {
                    // if it is not visible, delete this instance and create new below
                    instance.destroy();
                }
            }
        });
        if (!updated) {
            new Chart(myChartRef, {
                type: props.type,
                data: {
                    labels: props.labels,
                    datasets: props.datasets ??
                        [{
                            data: props.chartData.data,
                            borderWidth: 1,
                            backgroundColor: config.colors
                        }]
                },
                options: {
                    responsive: true,
                    title: {
                        text: props.title,
                        display: props.title ? true : false
                    },
                    legend: {
                        display: props.displayLegend ?? true,
                        position: props.legendPosition ?? 'bottom',
                    },
                    scales: {
                        x: {
                            stacked: true,
                        },
                        y: {
                            stacked: true
                        }
                    }                    
                },
            });
        }
    }, [props.title]);
    
    

    return (
        <canvas
            id={props.id}
            style={{ height: height, width: "100%" }}
            ref={chartRef}
        />
    )
}